import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "slack",
  "name": "Slack",
  "category": "integrations",
  "description": "Send messages and interact with Slack channels and users",
  "icon": "siSlack",
  "iconType": "simple-icon",
  "color": "purple",
  "version": "2.3.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "Slack",
    "color": "#4a154b"
  },
  "credentials": [
    {
      "name": "slackOAuth2",
      "required": true,
      "displayName": "Slack OAuth2"
    }
  ],
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "slack",
    "chat",
    "message",
    "communication",
    "team"
  ],
  "comingSoon": true
};

export default definition;
